module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-39.23943b0c.svg";